// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/satoshi);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-01: #16A9B4;
  --neutrals-white: #FDFDFD;
  --white: #FFFFFF;
  --grey-01: #ECECEC;
  --grey-06: #1E1E1C;
  --grey-07: #5F5F5F;
  --grey-08: #121D591A;
  --grey-09: #202020;
  --coral-light-blue: #EDF4F6;
  --light-grey-01: #81a7aa
}

body {
  margin: 0;
  font-family: 'Satoshi', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h2 {
  font-size: 48px;
  font-weight: 500;
  line-height: 1.4;
}

h3 {
  font-size: 32px;
  font-weight: 700;
}

h4 {
  font-size: 20px;
  font-weight: 700;
}

p {
  font-size: 16px;
  line-height: 1.9;
}

h2,
h3,
h4,
p {
  color: var(--grey-09);

}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
}

input {
  width: 100%;
  height: 48px;
  border-radius: 4px;
  /* opacity: 0px; */
  border: 1px solid #C8CBDE
}

label {
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: var(--grey-09);
  margin-bottom: 4px;
}

button.primary__btn {
  height: 47px;
  border: none !important;
  display: flex;
  gap: 7px;
  align-items: center;
  padding: 16px 20px 16px 20px;
  border-radius: 4px !important;
  background-color: var(--primary-01) !important;
  color: var(--neutrals-white) !important;
  cursor: pointer;
}

button.primary__btn:disabled {
	background: var(--light-grey-01) !important;
}

button>p,
button>svg {
  margin: 0;
}

.mb-40 {
  margin: 40px 0px !important;
}

@media (max-width: 768px) {
  h2 {
    font-size: 32px;
  }

  p {
    font-size: 14px;
  }

  .main__nav {
    display: none !important;
  }

  .mobile__nav {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
  }

}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;EAC3B;AACF;;AAIA;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;;AAEvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,8CAA8C;EAC9C,uCAAuC;EACvC,eAAe;AACjB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;EAC3C;;AAEF","sourcesContent":[":root {\n  --primary-01: #16A9B4;\n  --neutrals-white: #FDFDFD;\n  --white: #FFFFFF;\n  --grey-01: #ECECEC;\n  --grey-06: #1E1E1C;\n  --grey-07: #5F5F5F;\n  --grey-08: #121D591A;\n  --grey-09: #202020;\n  --coral-light-blue: #EDF4F6;\n  --light-grey-01: #81a7aa\n}\n\n@import url('https://fonts.cdnfonts.com/css/satoshi');\n\nbody {\n  margin: 0;\n  font-family: 'Satoshi', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh2 {\n  font-size: 48px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\nh3 {\n  font-size: 32px;\n  font-weight: 700;\n}\n\nh4 {\n  font-size: 20px;\n  font-weight: 700;\n}\n\np {\n  font-size: 16px;\n  line-height: 1.9;\n}\n\nh2,\nh3,\nh4,\np {\n  color: var(--grey-09);\n\n}\n\nmain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: hidden;\n}\n\ninput {\n  width: 100%;\n  height: 48px;\n  border-radius: 4px;\n  /* opacity: 0px; */\n  border: 1px solid #C8CBDE\n}\n\nlabel {\n  display: block;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: var(--grey-09);\n  margin-bottom: 4px;\n}\n\nbutton.primary__btn {\n  height: 47px;\n  border: none !important;\n  display: flex;\n  gap: 7px;\n  align-items: center;\n  padding: 16px 20px 16px 20px;\n  border-radius: 4px !important;\n  background-color: var(--primary-01) !important;\n  color: var(--neutrals-white) !important;\n  cursor: pointer;\n}\n\nbutton.primary__btn:disabled {\n\tbackground: var(--light-grey-01) !important;\n}\n\nbutton>p,\nbutton>svg {\n  margin: 0;\n}\n\n.mb-40 {\n  margin: 40px 0px !important;\n}\n\n@media (max-width: 768px) {\n  h2 {\n    font-size: 32px;\n  }\n\n  p {\n    font-size: 14px;\n  }\n\n  .main__nav {\n    display: none !important;\n  }\n\n  .mobile__nav {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
